"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Transition = exports.CustomSegmentLabelPosition = void 0;
var CustomSegmentLabelPosition = {
  Inside: "INSIDE",
  Outside: "OUTSIDE"
};
exports.CustomSegmentLabelPosition = CustomSegmentLabelPosition;
var Transition = {
  easeLinear: "easeLinear",
  easeQuadIn: "easeQuadIn",
  easeQuadOut: "easeQuadOut",
  easeQuadInOut: "easeQuadInOut",
  easeCubicIn: "easeCubicIn",
  easeCubicOut: "easeCubicOut",
  easeCubicInOut: "easeCubicInOut",
  easePolyIn: "easePolyIn",
  easePolyOut: "easePolyOut",
  easePolyInOut: "easePolyInOut",
  easeSinIn: "easeSinIn",
  easeSinOut: "easeSinOut",
  easeSinInOut: "easeSinInOut",
  easeExpIn: "easeExpIn",
  easeExpOut: "easeExpOut",
  easeExpInOut: "easeExpInOut",
  easeCircleIn: "easeCircleIn",
  easeCircleOut: "easeCircleOut",
  easeCircleInOut: "easeCircleInOut",
  easeBounceIn: "easeBounceIn",
  easeBounceOut: "easeBounceOut",
  easeBounceInOut: "easeBounceInOut",
  easeBackIn: "easeBackIn",
  easeBackOut: "easeBackOut",
  easeBackInOut: "easeBackInOut",
  easeElasticIn: "easeElasticIn",
  easeElasticOut: "easeElasticOut",
  easeElasticInOut: "easeElasticInOut",
  easeElastic: "easeElastic"
};
exports.Transition = Transition;